<template lang="pug">
  .create-account
    .top-wrap
      p.sign-in-title.kapra-neue.upper.xs-f-xgrande.max-at-tweak Create Your Account
      p.text-color-2.xs-f-small.max-at-tweak
        | With your email address&#32;
        br
        span.user-email.semi-bold {{ userEmail }}
        | &#32;
        button.change-email.btn-reset.text-color-3.underline(@click="setView('signIn')") Change

    form#create_account_form(name='create_account_form' @submit.prevent="createAccount" novalidate)
      .mr-input-wrap
        MrPasswordInput(v-model="password" :required="true" label="Enter a password" autocomplete="new-password" data-mr-ass="create-account-password" name='password')

      .captcha(v-if="showCaptcha")
        Captcha(@captcha-response="setCaptchaResponse")

      .birthday-inputs(v-if="showBirthdayInput")
        p.xs-f-small.max-at-tweak Birthday (optional)
        .birthday-input
          MrDropdown(label="Month" :options="months" v-model="bdayMonth")
        .birthday-input
          MrDropdown(label="Day" :options="days" v-model="bdayDay")

      .mr-input-wrap
        mrInputCheckbox.xs-mt-100m.xs-mb-100m(v-model="staySignedIn" :dataMrAss="'keep-me-signed-in'" :label="'Keep me signed in'")

      template(v-if="showOptIn")
        mrInputCheckbox.xs-mt-100m.xs-mb-100m(v-model="optInEmailValue" :dataMrAss="'opt-in-email'" label="Email me about exclusive promotions, hair tips and events near me")

      button.mr-btn.btn-block.font-xsmall(type='submit' :disabled="v$.$invalid || processing" :class="{ disabled: v$.$invalid || processing }" data-mr-ass="sign-in") Continue

      p.terms-text.text-color-2.xs-f-xsmall.max-at-tweak.pt-100m
        | By creating an account, you agree to the&#32;
        br
        a(href='/about/terms' target='_blank') Terms&nbsp;of&nbsp;Use
        |  and
        a(href='/about/privacy' target='_blank')  Privacy&nbsp;Policy

</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';

  import Captcha from "@components/captcha";
  import MrPasswordInput from '@components/MrPasswordInput';
  import MrDropdown from "@components/MrDropdown";
  import mrInputCheckbox from "@components/mrInputCheckbox";
  import {useVuelidate} from "@vuelidate/core";

  export default {
    name: "CreateAccount",

    components: {
      Captcha,
      MrPasswordInput,
      MrDropdown,
      mrInputCheckbox,
    },

    props: {
      showBirthdayInput: {
        default: false,
        type: Boolean
      }
    },

    data() {
      return {
        showOptIn: false,
        months: [
          { label: "1", value: 1 },
          { label: "2", value: 2 },
          { label: "3", value: 3 },
          { label: "4", value: 4 },
          { label: "5", value: 5 },
          { label: "6", value: 6 },
          { label: "7", value: 7 },
          { label: "8", value: 8 },
          { label: "9", value: 9 },
          { label: "10", value: 10 },
          { label: "11", value: 11 },
          { label: "12", value: 12 }
        ]
      };
    },

    computed: {
      ...mapState('signIn', [
        'accountStatus',
        'userEmail',
        'processing',
        'showCaptcha',
        'userPassword',
        'passwordValidators',
        'birthdayDay',
        'birthdayMonth',
        'keepMeSignedIn',
        'optInEmail',
        'code',
      ]),

      password: {
        get() {
          return this.userPassword;
        },

        set(value) {
          this.setUserPassword(value);
        }
      },

      staySignedIn: {
        get() {
          return this.keepMeSignedIn;
        },

        set(val) {
          this.setKeepMeSignedIn(val);
        }
      },

      optInEmailValue: {
        get() {
          return this.optInEmail;
        },

        set(value) {
          this.setOptInEmail(value);
        }
      },

      bdayDay: {
        get() {
          return this.birthdayDay;
        },

        set(val) {
          this.setBirthdayDay(val);
        }
      },

      bdayMonth: {
        get() {
          return this.birthdayMonth;
        },

        set(val) {
          this.setBirthdayMonth(val);
        }
      },

      days() {
        let days = [];
        let month = this.birthdayMonth || 1;

        let numDays = new Date(1896, month, 0).getDate();
        for (var x = 1; x <= numDays; x++) {
          days.push({ label: "" + x, value: x });
        }

        if (this.birthdayDay > numDays) {
          this.birthdayDay = null; // eslint-disable-line
        }

        return days;
      },

      showSignUpCaptcha() {
        let enabled = this.getObjProperty(this.captchaSettings, 'enabled');
        let strictOnSignUp = this.getObjProperty(this.captchaSettings, 'strictOnSignUp');
        return enabled && (strictOnSignUp || this.showCaptcha);
      }
    },

    setup () {
      return {
        v$: useVuelidate()
      };
    },


    validations() {
      return {
        password: this.passwordValidators
      };
    },

    methods: {
      ...mapActions('signIn', [
        'resetPassword',
        'signIn',
        'createCustomer',
      ]),

      ...mapMutations('signIn', [
        'setUserPassword',
        'setCaptchaResponse',
        'setKeepMeSignedIn',
        'setOptInEmail',
        'setBirthdayDay',
        'setBirthdayMonth',
        'setView'
      ]),

      createAccount() {
        if (this.code) {
          this.resetPassword().then(this.signIn);
        } else {
          // create customer
          this.createCustomer();
        }
      },
    },

    mounted() {
      if (this.accountStatus == 'no_account') {
        this.showOptIn = true;
      }
    }
  };
</script>

<style scoped lang="stylus">
  .create-account
    .birthday-input
      display inline-block
      vertical-align top
      margin-right 1em
      margin-top 0.25em

</style>
